import { EmploymentOccupation } from "../../lead-api";
import { type OccupationMenuItem } from "../Employment.types";

const tKey = "inputs.employment.";

export const occupationMenuItemsVn: OccupationMenuItem[] = [
  {
    label: tKey + EmploymentOccupation.BlueCollar.toLowerCase(),
    value: EmploymentOccupation.BlueCollar,
  },

  {
    label: tKey + EmploymentOccupation.BusinessOwner.toLowerCase(),
    value: EmploymentOccupation.BusinessOwner,
  },

  {
    label: tKey + EmploymentOccupation.Driver.toLowerCase(),
    value: EmploymentOccupation.Driver,
  },

  {
    label: tKey + EmploymentOccupation.Employed.toLowerCase(),
    value: EmploymentOccupation.Employed,
  },

  {
    label: tKey + EmploymentOccupation.Farmer.toLocaleLowerCase(),
    value: EmploymentOccupation.Farmer,
  },

  {
    label: tKey + EmploymentOccupation.Freelancer.toLowerCase(),
    value: EmploymentOccupation.Freelancer,
  },

  {
    label: tKey + EmploymentOccupation.MilitaryPersonnel.toLowerCase(),
    value: EmploymentOccupation.MilitaryPersonnel,
  },

  {
    label: tKey + EmploymentOccupation.Police.toLowerCase(),
    value: EmploymentOccupation.Police,
  },

  {
    label: tKey + EmploymentOccupation.Retired.toLowerCase(),
    value: EmploymentOccupation.Retired,
  },

  {
    label: tKey + EmploymentOccupation.SelfEmployed.toLowerCase(),
    value: EmploymentOccupation.SelfEmployed,
  },

  {
    label: tKey + EmploymentOccupation.Unemployed.toLowerCase(),
    value: EmploymentOccupation.Unemployed,
  },

  {
    label: tKey + EmploymentOccupation.WhiteCollar.toLowerCase(),
    value: EmploymentOccupation.WhiteCollar,
  },

  {
    label: tKey + EmploymentOccupation.Student.toLowerCase(),
    value: EmploymentOccupation.Student,
  },

  {
    label: tKey + EmploymentOccupation.Other.toLowerCase(),
    value: EmploymentOccupation.Other,
  },
];
